

























import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { ModalNdcList } from '@/components/modals/ModalNdcList'

@Component({
  components: {
    ModalNdcList
  }
})
export default class InputCodeNdcList extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Ref()
  modalNdcList!: ModalNdcList

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: String })
  value!: string

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Emit('input')
  onInput(value: string): string {
    return value
  }

  @Emit('input')
  onModalNdcListInput(data: string): string {
    return data
  }

  @Emit('click:list')
  onListClick(): void {
    this.modalNdcList.open()
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
